//异常 表格
import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { Card, Table, App, Pagination, Badge, theme, Tag } from 'antd';
import { GetAnomalous, GetAnomalousImage } from '@/server/anomalous'

function Anomalous (props) {
  const { message } = App.useApp();
  const { getInfo } = props //父组件方法
  const navigate = useNavigate();//路由跳转
  const {
    token: { colorText, colorTextPlaceholder },
  } = theme.useToken(); //获取主题颜色
  const token = localStorage.getItem('dock_token');
  const [data, setData] = useState([]);//表格数据
  const [loading, setLoading] = useState(false);//表格加载
  const [searchList, setSearchList] = useState({
    access_token: token,
    title: '',
    company: '',
    order: '',
    page: 1,
    perpage: 10,
  })

  const [dictionaryList, setDictionaryList] = useState({//数据字典
    typeList: [],
  })

  const [cur, setCur] = useState(1);//当前页
  const [page, setPage] = useState(10);//每页多少条
  const [total, setTotal] = useState(0);//总条数


  //表格头
  const columns = [
    {
      title: '类型',
      dataIndex: 'routes_type',
      render: (text, record) => {
        return (
          text
            ? <div>{record.routes_typename}</div>
            : <div style={{ color: colorTextPlaceholder }}>-</div>
        )
      },
      filters: dictionaryList.typeList,
      filterMultiple: false,
    },
    {
      title: '机场',
      dataIndex: 'dockName',
      render: (text, record) => {
        return (
          text
            ? <div>{text}</div>
            : <div style={{ color: colorTextPlaceholder }}>-</div>
        )
      },
    },
    {
      title: '航线名称', dataIndex: 'routes_name',
    },
    {
      title: '状态', dataIndex: 'ins_status',
      render: (text, record) => {
        return (
          <div className='flex'>
            <div>
              <Tag style={{ display: text === 1 ? `block` : `none` }}
                icon={<CheckCircleOutlined />} color="success">
                完成
              </Tag>
            </div>
            <div>
              <Tag style={{ display: text === 2 ? `block` : `none` }}
                icon={<SyncOutlined spin />} color="processing">
                执行中
              </Tag>
            </div>
            <div>
              <Tag style={{ display: text === 3 ? `block` : `none` }}
                icon={<CloseCircleOutlined />} color="error">
                失败
              </Tag>
            </div>
          </div>
        )
      },
      // sorter: () => { }
    },

    {
      title: '待排查', dataIndex: 'check_count',
      render: (text, record) => {
        return (
          <div>
            <div style={{ display: Number(text) > 0 ? `block` : `none` }} className='pointer' onClick={() => {
              getAllDataArr(record)
            }} >
              <Badge style={{ color: colorText }} count={text} />
            </div>
            <div style={{ display: Number(text) <= 0 ? `block` : `none` }}>暂无</div>
          </div>
        )
      },
      // sorter: () => { }
    },
    {
      title: '巡检起止',
      render: (text, record) => {
        return (
          <span>
            <span>
              {record.start_time?.split(' ')[0]} <span className='opa45'> {record.start_time?.split(' ')[1]} </span>
            </span>
            <span style={{ color: (record.end_time) ? colorText : 'var(--error-color)' }}> ~ </span>
            <span>
              {record.end_time?.split(' ')[0]} <span className='opa45'> {record.end_time?.split(' ')[1]} </span>
            </span>
          </span>
        )
      },
      // sorter: () => { }
    },
  ];
  //获取所有数据
  const getAllDataArr = async (record) => {
    let obj = {
      access_token: token,
      statid: record.id,
      insIds: record.InsIDs
    }
    let res = await GetAnomalousImage(obj)
    if (res.ret === 200) {
      if (res.data.list && res.data.list.length > 0) {
        let obj = {
          showMain: false,
          arr: res.data.list,
          len: res.data.list.length,
          routes_type: Number(record.routes_type)
        }
        // window.sessionStorage.setItem(`abnormal`, JSON.stringify(obj))
        getInfo(obj)
        // navigate('/Troubleshoot', { state: { arr: res.data.list, len: res.data.list.length } })
      }
    } else {
      message.warning(res.msg || `服务器开了小差，请重试`)
    }
  }
  //初始化获取数据
  const initialize = async (obj) => {
    setLoading(true);
    let res = await GetAnomalous(obj);
    setLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }

    let dic = dictionaryList
    dic.typeList = res.data.sjzd.typeList.map((res) => { return { text: res.label, value: res.value } })
    setDictionaryList({ ...dic })
    let val = res.data;
    setTotal(val.total);
    setData([...val.items]);
  }

  useEffect(() => {
    initialize(searchList);
    //eslint-disable-next-line
  }, [])

  return (
    <Card style={{ border: 0 }} className="mar24" styles={{ body: { padding: '24px' } }}>
      {/* 主表格 */}
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        loading={loading}
        rowKey='id'
        onChange={(pagination, filters, sorter) => {
          let obj = { ...searchList }
          obj.routes_type = filters.routes_type ? filters.routes_type[0] : null
          // obj.company = sorter.field
          setSearchList({ ...obj })
          initialize(obj)
        }}
      >
      </Table>

      {/* 分页 */}
      <div className='pdT16 '>
        <Pagination align='end' current={cur} pageSize={page} total={total} showTotal={total => `共 ${total} 条数据`}
          onChange={
            (current, pageSize) => { //选择当前页后执行
              let obj = { ...searchList }
              obj.page = current
              obj.perpage = pageSize
              setSearchList(obj)
              setCur(current);
              setPage(pageSize);
              initialize(obj);
            }
          } />
      </div>
    </Card>
  )
}
export default Anomalous